<template>
  <Container title="提现管理">
	<!-- 搜索卡片 -->
	<el-card shadow="never" class="search-card">
	  <el-form :model="searchForm" label-position="left" label-width="70px" @submit.prevent @keyup.enter="handleSearch">
		<el-row :gutter="20">
		  <!-- 企业 (仅超管) -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
			<el-form-item label="企业">
			  <el-select v-model="searchForm.enterpriseId" placeholder="请选择企业" clearable style="width: 100%;" @change="handleEnterpriseChange">
				<el-option v-for="item in enterpriseList" :key="item.id" :label="item.name" :value="item.id" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 站点 (仅超管) -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
			<el-form-item label="站点">
			  <el-select v-model="searchForm.stationId" placeholder="请选择站点" clearable style="width: 100%;" :disabled="!searchForm.enterpriseId">
				<el-option v-for="item in stationOptions" :key="item.id" :label="item.name" :value="item.id" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 提现类型 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6">
			<el-form-item label="提现类型">
			  <el-select v-model="searchForm.withdrawType" placeholder="请选择类型" clearable style="width: 100%;">
				<el-option label="站点提现" :value="1" />
				<el-option label="企业提现" :value="2" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 状态 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6">
			<el-form-item label="状态">
			  <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 100%;">
				<el-option label="待审核" value="pending" />
				<el-option label="处理中" value="processing" />
				<el-option label="提现成功" value="success" />
				<el-option label="提现失败" value="failed" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 时间 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6">
			<el-form-item label="时间">
			  <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" value-format="YYYY-MM-DD" :shortcuts="shortcuts" style="width: 100%;" />
			</el-form-item>
		  </el-col>
		  
		  <!-- 按钮区域：统一占 6，跟在后面靠右 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" style="display: flex; justify-content: flex-end;">
			<el-form-item label=" " label-width="0">
			  <div style="display: flex; gap: 8px;">
				<el-button type="primary" @click="handleSearch">查询</el-button>
				<el-button @click="resetSearch">重置</el-button>
			  </div>
			</el-form-item>
		  </el-col>
		</el-row>
	  </el-form>
	</el-card>

    <el-card shadow="never" class="table-card">
      <template #header>
        <div class="table-header">
          <div class="table-header-left"></div>
          <div class="table-header-right">
            <el-tooltip content="刷新" placement="bottom"><el-button circle @click="fetchData"><el-icon><Refresh /></el-icon></el-button></el-tooltip>
            <el-tooltip content="导出" placement="bottom"><el-button circle @click="handleExport"><el-icon><Download /></el-icon></el-button></el-tooltip>
            <el-tooltip content="打印" placement="bottom"><el-button circle @click="handlePrint"><el-icon><Printer /></el-icon></el-button></el-tooltip>
          </div>
        </div>
      </template>

      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="提现类型" min-width="110" align="center">
          <template #default="{ row }"><el-tag :type="row.withdraw_type === 1 ? 'primary' : 'success'" size="small">{{ row.withdraw_type === 1 ? '站点提现' : '企业提现' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="enterprise_name" label="企业名" min-width="120" show-overflow-tooltip />
        <el-table-column prop="station_name" label="站点名" min-width="120" show-overflow-tooltip />
        <el-table-column prop="merchant_no" label="支付商户" min-width="150" show-overflow-tooltip />
        <el-table-column label="提现金额" min-width="110" align="right"><template #default="{ row }">{{ row.withdraw_amount != null ? Number(row.withdraw_amount).toFixed(2) : '0.00' }}</template></el-table-column>
        <el-table-column label="申请金额" min-width="110" align="right"><template #default="{ row }">{{ row.apply_amount != null ? Number(row.apply_amount).toFixed(2) : '0.00' }}</template></el-table-column>
        <el-table-column label="完成金额" min-width="110" align="right"><template #default="{ row }">{{ row.complete_amount != null ? Number(row.complete_amount).toFixed(2) : '0.00' }}</template></el-table-column>
        <el-table-column prop="holder_name" label="持卡人" min-width="100" show-overflow-tooltip />
        <el-table-column prop="bank_card" label="卡号" min-width="180" show-overflow-tooltip />
        <el-table-column label="提现状态" min-width="100" align="center">
          <template #default="{ row }"><el-tag :type="getStatusType(row.status)" size="small">{{ getStatusText(row.status) }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column label="申请时间" min-width="160"><template #default="{ row }">{{ formatTime(row.apply_time) }}</template></el-table-column>
        <el-table-column label="到账时间" min-width="160"><template #default="{ row }">{{ formatTime(row.arrival_time) }}</template></el-table-column>
        <el-table-column label="创建时间" min-width="160"><template #default="{ row }">{{ formatTime(row.created_at) }}</template></el-table-column>
        <el-table-column label="操作" min-width="160" fixed="right" align="center">
          <template #default="{ row }">
            <el-button type="primary" size="small" plain @click="openDetail(row)">详情</el-button>
            <el-dropdown
              v-if="row.status === 'pending'"
              trigger="hover"
              @command="(cmd) => handleAuditCommand(row, cmd)"
              style="margin-left: 6px;"
            >
              <el-button type="warning" size="small" plain>
                审核 <el-icon><ArrowDown /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="pass">通过</el-dropdown-item>
                  <el-dropdown-item v-if="$hasPermission('btn:reject_withdraw')" command="reject">驳回</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="page.current"
          v-model:page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="onSizeChange"
          @current-change="fetchData"
        />
      </div>
    </el-card>

    <!-- 提现详情弹窗 -->
    <el-dialog v-model="detailDialogVisible" title="提现详情" width="500px" :close-on-click-modal="false">
      <div style="padding: 10px 0;">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="订单号">{{ detailData.order_no || '-' }}</el-descriptions-item>
          <el-descriptions-item label="流水号">{{ detailData.flow_no || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请时间">{{ detailData.apply_time ? formatTime(detailData.apply_time) : '-' }}</el-descriptions-item>
          <el-descriptions-item label="到账时间">{{ detailData.arrival_time ? formatTime(detailData.arrival_time) : '-' }}</el-descriptions-item>
          <el-descriptions-item label="提现状态"><el-tag :type="getStatusType(detailData.status)" size="small">{{ getStatusText(detailData.status) }}</el-tag></el-descriptions-item>
          <el-descriptions-item label="审核人">{{ detailData.auditor || '-' }}</el-descriptions-item>
          <el-descriptions-item label="持卡人">{{ detailData.holder_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="收款账号">{{ detailData.bank_card || '-' }}</el-descriptions-item>
          <el-descriptions-item label="提现金额">{{ detailData.withdraw_amount ? Number(detailData.withdraw_amount).toFixed(2) : '0.00' }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ detailData.remark || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 驳回理由弹窗 -->
    <el-dialog v-model="auditDialogVisible" title="驳回理由" width="420px" :close-on-click-modal="false">
      <div style="padding: 10px 0;">
        <div style="margin-bottom: 16px; font-size: 14px; color: #606266;">
          提现单号：{{ auditData.id }}<br />
          持卡人：{{ auditData.holder_name }}<br />
          提现金额：{{ auditData.withdraw_amount?.toFixed(2) }} 元
        </div>
        <el-input
          v-model="auditRejectReason"
          type="textarea"
          :rows="4"
          placeholder="请输入驳回理由（必填）"
        />
      </div>
      <template #footer>
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReject" :loading="auditSubmitting">确定驳回</el-button>
      </template>
    </el-dialog>

    <ExportDialog
      v-model:visible="exportDialogVisible"
      :fields="exportFields"
      :export-api="exportApi"
      :get-search-params="getSearchParams"
      :current-page="page"
      :default-file-name="defaultFileName()"
    />
  </Container>
</template>

<script>
import { pub } from '/common/event';
import moment from 'moment';
import { Plus, Refresh, Download, Printer, ArrowDown } from '@element-plus/icons-vue';
import ExportDialog from '@/components/container/ExportDialog.vue';
import exportMixin from '@/mixins/exportMixin';
import enterpriseStationMixin from '@/mixins/enterpriseStationMixin';
import { dateShortcuts } from '../../../utils/shortcuts.js';

export default {
  components: { Plus, Refresh, Download, Printer, ArrowDown, ExportDialog },
  mixins: [exportMixin, enterpriseStationMixin],
  data() {
    return {
      shortcuts: dateShortcuts,
      searchForm: { enterpriseId: null, stationId: null, withdrawType: null, status: null, dateRange: null },
      tableData: [],
      total: 0,
      page: { current: 1, pageSize: 15 },
      detailDialogVisible: false,
      detailData: {},
      auditDialogVisible: false,
      auditData: {},
      auditRejectReason: '',
      auditSubmitting: false,
      exportFields: [
        { key: 'id', label: '序号列', checked: true },
        { key: 'withdraw_type_label', label: '提现类型', checked: true },
        { key: 'enterprise_name', label: '企业名', checked: true },
        { key: 'station_name', label: '站点名', checked: true },
        { key: 'merchant_no', label: '支付商户', checked: true },
        { key: 'withdraw_amount', label: '提现金额', checked: true },
        { key: 'apply_amount', label: '申请金额', checked: true },
        { key: 'complete_amount', label: '完成金额', checked: true },
        { key: 'holder_name', label: '持卡人', checked: true },
        { key: 'bank_card', label: '卡号', checked: true },
        { key: 'status_label', label: '提现状态', checked: true },
        { key: 'remark', label: '备注', checked: true },
        { key: 'apply_time_label', label: '申请时间', checked: true },
        { key: 'arrival_time_label', label: '到账时间', checked: true },
        { key: 'created_at_label', label: '创建时间', checked: true },
      ],
    };
  },
  computed: {
    exportApi() {
      return this.$api.withdraw.exportData;
    },
	// ★ 新增：超管判断
	isSuperAdmin() {
	  const u1 = this.$store.state.user?.user;
	  if (u1 && u1.role) return u1.role === 'super_admin';
	  try {
		const u2 = JSON.parse(localStorage.getItem('user') || '{}');
		return u2.role === 'super_admin' || u2.role_id === 1;
	  } catch (e) { return false; }
	},
  },
  mounted() {
    const today = moment().format('YYYY-MM-DD');
    this.searchForm.dateRange = [today, today];
	// ★ 如果非超管，自动带入自己的企业或站点参数
	if (!this.isSuperAdmin) {
	  try {
		const u = JSON.parse(localStorage.getItem('user') || '{}');
		if (u.role === 'admin' && u.enterprise_id) {
		  this.searchForm.enterpriseId = u.enterprise_id;
		} else if (u.role === 'station_leader' && u.station_id) {
		  this.searchForm.stationId = u.station_id;
		}
	  } catch (e) {}
	}
    this.fetchData();
  },
  methods: {
    defaultFileName() {
      return '提现数据';
    },
    formatTime(ts) {
      if (!ts) return '';
      return moment(ts).format('YYYY-MM-DD HH:mm:ss');
    },
    getStatusText(status) {
      const map = { pending: '待审核', processing: '处理中', success: '提现成功', failed: '提现失败' };
      return map[status] || status;
    },
    getStatusType(status) {
      const map = { pending: 'warning', processing: 'info', success: 'success', failed: 'danger' };
      return map[status] || '';
    },

    async fetchData() {
      try {
        const params = {
          page: this.page.current,
          pageSize: this.page.pageSize,
          withdrawType: this.searchForm.withdrawType || undefined,
          enterpriseId: this.searchForm.enterpriseId || undefined,
          stationId: this.searchForm.stationId || undefined,
          status: this.searchForm.status || undefined,
        };
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startTime = new Date(this.searchForm.dateRange[0]).getTime();
          params.endTime = new Date(this.searchForm.dateRange[1]).getTime() + 24 * 60 * 60 * 1000 - 1;
        }
        const ret = await this.$api.withdraw.page(params);
        if (ret && ret.success) {
          this.tableData = ret.data.data || [];
          this.total = ret.data.total || 0;
          if (ret.data.page) {
            this.page.current = ret.data.page.current;
            this.page.pageSize = ret.data.page.pageSize;
          }
        } else {
          pub('error_message', ret?.message || '加载数据失败');
        }
      } catch (e) {
        console.error('加载提现列表失败:', e);
        pub('error_message', '请求失败');
      }
    },
    onSizeChange() {
      this.page.current = 1;
      this.fetchData();
    },
    handleSearch() {
      this.page.current = 1;
      this.fetchData();
    },
    resetSearch() {
      this.searchForm = { enterpriseId: null, stationId: null, withdrawType: null, status: null, dateRange: null };
      this.stationOptions = [];
      this.page.current = 1;
      this.fetchData();
    },
    openDetail(row) {
      this.detailData = { ...row };
      this.detailDialogVisible = true;
    },
    handleExport() {
      this.openExportDialog();
    },
    handlePrint() {
      window.print();
    },

    handleAuditCommand(row, command) {
      if (command === 'pass') {
        this.submitAudit(row, 'success');
      } else if (command === 'reject') {
        this.auditData = { ...row };
        this.auditRejectReason = '';
        this.auditDialogVisible = true;
      }
    },

    async submitAudit(row, status) {
      if (status === 'success') {
        try {
          await this.$confirm(
            `确认通过提现单 ${row.id}？\n持卡人：${row.holder_name || '-'}\n金额：￥${Number(row.withdraw_amount || 0).toFixed(2)}`,
            '审核通过确认',
            { type: 'warning', confirmButtonText: '确认通过', cancelButtonText: '取消' }
          );
        } catch {
          return;
        }
      }

      this.auditSubmitting = true;
      try {
        const ret = await this.$api.withdraw.approve({ id: row.id, status: 'success' });
        if (ret && ret.success) {
          pub('success_message', '审核通过');
          this.fetchData();
        } else {
          pub('error_message', ret?.message || '操作失败');
        }
      } catch (e) {
        console.error('审核异常', e);
        const msg = e?.response?.data?.message || e?.data?.message || e?.message || '请求失败';
        pub('error_message', msg);
      } finally {
        this.auditSubmitting = false;
      }
    },

    async confirmReject() {
      if (!this.auditRejectReason.trim()) {
        pub('error_message', '驳回理由不能为空');
        return;
      }
      this.auditSubmitting = true;
      try {
        const ret = await this.$api.withdraw.reject({
          id: this.auditData.id,
          rejectReason: this.auditRejectReason.trim(),
        });
        if (ret && ret.success) {
          pub('success_message', '已驳回');
          this.auditDialogVisible = false;
          this.fetchData();
        } else {
          pub('error_message', ret?.message || '驳回失败');
        }
      } catch (e) {
        console.error('驳回异常', e);
        pub('error_message', '请求失败');
      } finally {
        this.auditSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.search-card { margin-bottom: 16px; }
.table-card :deep(.el-card__header) { padding: 10px 16px; border-bottom: 1px solid #e4e7ed; }
.table-header { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.table-header-left { display: flex; align-items: center; gap: 8px; }
.table-header-right { display: flex; align-items: center; gap: 4px; }
.pagination-wrapper { display: flex; justify-content: center; margin-top: 16px; }
</style>